/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../shared/generated.types'

import { api } from '../../utils'
export const AuditRecordCallerFragment = `
    fragment AuditRecordCallerFragment on ApiAuditEntryCaller {
  cognitoId
  treatmentId
}
    `
export const AuditRecordFragment = `
    fragment AuditRecordFragment on ApiAuditEntry {
  requestTimestamp
  apiName
  endpoint
  endpointMethod
  responseStatus
  caller {
    ...AuditRecordCallerFragment
  }
}
    `
export const SearchWriteEventsDocument = `
    query searchWriteEvents($query: AWSJSON!, $sort: AWSJSON, $pageSize: Int, $from: Int, $searchAfter: AWSJSON, $aggregations: AWSJSON) {
  searchWriteEvents(
    query: $query
    sort: $sort
    pageSize: $pageSize
    from: $from
    searchAfter: $searchAfter
    aggregations: $aggregations
  ) {
    audits {
      ...AuditRecordFragment
    }
    resultCount
    from
    searchAfter
    aggregations
  }
}
    ${AuditRecordFragment}
${AuditRecordCallerFragment}`
export const SearchCreatedLastModifiedDocument = `
    query searchCreatedLastModified($queryCreated: AWSJSON!, $queryModified: AWSJSON!, $sort: AWSJSON!, $modifiedPageSize: Int) {
  createdEvents: searchWriteEvents(query: $queryCreated, sort: $sort, pageSize: 1) {
    audits {
      ...AuditRecordFragment
    }
  }
  updatedEvents: searchWriteEvents(
    query: $queryModified
    sort: $sort
    pageSize: $modifiedPageSize
  ) {
    audits {
      ...AuditRecordFragment
    }
  }
}
    ${AuditRecordFragment}
${AuditRecordCallerFragment}`

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    searchWriteEvents: build.query<
      Types.SearchWriteEvents,
      Types.SearchWriteEventsVariables
    >({
      query: (variables) => ({
        document: SearchWriteEventsDocument,
        variables,
      }),
    }),
    searchCreatedLastModified: build.query<
      Types.SearchCreatedLastModified,
      Types.SearchCreatedLastModifiedVariables
    >({
      query: (variables) => ({
        document: SearchCreatedLastModifiedDocument,
        variables,
      }),
    }),
  }),
})

export { injectedRtkApi as api }
